import React, { Component } from 'react';
import './CentralTimesItem.css';

class CentralTimesItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data: { title, pdfUrl } } = this.props;
    return (
      <div className="centralTimesItem ui raised segment">
        <div>
          <strong>{title}</strong>
        </div>
        <div className="downloadButtonBlock">
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            <button className="ui primary button">Download</button>
          </a>
        </div>
      </div>
    );
  }
}

export default CentralTimesItem;

